import { IFecha } from '../interface';
export const isMobile =():boolean =>{
    let p = 
        (navigator.userAgent.match(/Android/i)) ||
        (navigator.userAgent.match(/webOS/i)) ||
        (navigator.userAgent.match(/iPhone/i)) ||
        (navigator.userAgent.match(/iPod/i)) ||
        (navigator.userAgent.match(/iPad/i)) ||
        (navigator.userAgent.match(/BlackBerry/i))
    return !!p;
}

const obtenerDia = (dia:string):string => {
    switch (dia) {
        case 'Mon':
            return 'Lunes';
        case 'Tue':
            return 'Martes';
        case 'Wed':
            return 'Miercoles';
        case 'Thu':
            return 'Jueves';
        case 'Fri':
            return 'Viernes';
        case 'Sat':
            return 'Sabado';
        case 'Sun':
            return 'Domingo';
        default:
            return dia
    }
}
const obtenerMes = (mes:string):string => {
    switch (mes) {
        case '01':
            return 'Enero';
        case '02':
            return 'Febrero';
        case '03':
            return 'Marzo';
        case '04':
            return 'Abril';
        case '05':
            return 'Mayo';
        case '06':
            return 'Junio';
        case '07':
            return 'Julio';
        case '08':
            return 'Agosto';
        case '09':
            return 'Septiembre';
        case '10':
            return 'Octubre';
        case '11':
            return 'Noviembre';
        case '12':
            return 'Diciembre';
        case 'Jan':
            return 'Enero';
        case 'Feb':
            return 'Febrero';
        case 'Mar':
            return 'Marzo';
        case 'Apr':
            return 'Abril';
        case 'May':
            return 'Mayo';
        case 'Jun':
            return 'Junio';
        case 'Jul':
            return 'Julio';
        case 'Aug':
            return 'Agosto';
        case 'Sep':
            return 'Septiembre';
        case 'Oct':
            return 'Octubre';
        case 'Nov':
            return 'Noviembre';
        case 'Dec':
            return 'Diciembre';
        default:
            return mes
    }
}

export const fechaOrganizada = (fecha:string):IFecha => {
    const fechaOr = fecha.split(" ");

    return {
        diaNombre: obtenerDia(fechaOr[0]),
        mes: obtenerMes(fechaOr[1]),
        dia: fechaOr[2],
        anio: fechaOr[3],
        hora: fechaHoraOrganizada(fecha)
    } as IFecha;
}

export const fechaOrganizadaAlert = (fecha:string):any => {
    let fechas = fechaOrganizada(fecha);

    return (`${fechas.mes} ${fechas.dia} ${fechas.anio}, a las ${fechas.hora}`);
}

export const fechaHoraOrganizada =(fecha:string):any =>{
    let date = new Date(fecha);
    let options = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    };
    let timeString = date.toLocaleString('en-US', options);
    return timeString;

}

export const permitirNotifiaciones = ():Promise<boolean> => {
    return new Promise((resolve,reject) => {
        // Comprobamos si el navegador soporta las notificaciones
        if (!("Notification" in window)) {
            alert("Este navegador no soporta las notificaciones del sistema");
        }
      
        // Comprobamos si ya nos habían dado permiso
        else if (Notification.permission === "granted") {
          // Si esta correcto lanzamos la notificación
            resolve(true)
        }
      
        // Si no, tendremos que pedir permiso al usuario
        else if (Notification.permission !== 'denied') {
            Notification.requestPermission(function (permission) {
            // Si el usuario acepta, lanzamos la notificación
                if (permission === "granted") {
                    resolve(true)
                }else{
                    reject()
                }
            });
        }
    })
    // Finalmente, si el usuario te ha denegado el permiso y 
    // quieres ser respetuoso no hay necesidad molestar más.
  }

export const decoded = async(token:string):Promise<string> => {
    try {
        const res = await fetch('https://autenticacion-web-dot-cm-autenticacion-test.appspot.com/api/v1/token/decode', {
            method: 'POST', 
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+token
            }
            });
            const jsonResponse = await res.json();
            return jsonResponse['response']['guia'];
    } catch (error) {
        throw error;
    }
}

export const nombreMensaje = (nombre:string,tipo:string) => {
    switch (tipo) {
        case 'Cliente':
            return `Destinatario: ${nombre}`;
            
        case 'Repartidor':
            return `Repartidor: ${nombre}`;

        case 'Asesor':
            return `Asesor: ${nombre}`;
    
        default:
            return nombre;

    }
}

export const fechaHora = (fecha:string,hora:string) =>{
    const fecha_completa = `${fecha}  ${hora.toString().substring(16,24)}`;
    return fecha_completa;
}

export const URL_BACK='https://cm-nys-dot-cm-nys-test.appspot.com/api/v1';